import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Home'
import About from './About'
import Portfolio from './Portfolio'
import Game from './Game'
import Tiktaktoe from './Tiktaktoe'
import Plusgame from './Plusgame'
import Quiz from './Quiz'
import Morequiz from './Morequiz'

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/portfolio' element={<Portfolio/>}/>
          <Route path='/game' element={<Game/>}/>
          <Route path='/tiktaktoe' element={<Tiktaktoe/>}/>
          <Route path='/mathgame' element={<Plusgame/>}/>
          <Route path='/indiaquiz' element={<Quiz/>}/>
          <Route path='/worldquiz' element={<Morequiz/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App